import Vue from 'vue'
import Vuex from 'vuex'
import basicorderinformation from './modules/basicorderinformation'
import prescription from './modules/prescription'
import lineitems from './modules/lineitems'
import cxframe from './modules/cxframe'
import tint from './modules/tint'
import notes from './modules/notes'
import dates from './modules/dates'
import customcharges from './modules/customcharges'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	modules: {
		basicorderinformation,
		prescription,
		lineitems,
		cxframe,
		tint,
		notes,
		dates,
		customcharges
	},
	actions: {
		collateOrder ({ rootGetters, rootState, state, commit }) {
			let payload = new Object();
			payload.jobCategory				= rootGetters.jobCategory
			payload.jobID					= rootGetters.jobID
			payload.account					= rootGetters.account
			payload.discount				= rootGetters.discount
			payload.reference				= rootGetters.reference
			payload.referenceID				= rootGetters.referenceID
			payload.inputBy					= rootGetters.inputBy
			payload.trackingID				= rootGetters.trackingID
			payload.zone					= rootGetters.zone
			payload.estimated				= rootGetters.estimatedCompletion
			payload.adjustedEstimated		= rootGetters.adjustedEstimatedCompletion
			payload.adjustedEstimatedReason	= rootGetters.adjustedEstimatedCompletionReason
			payload.dispatched				= rootGetters.dispatched
			payload.action					= rootGetters.actionDate
			payload.deliverySpeed			= rootGetters.deliverySpeed
			payload.focusNotes				= rootGetters.foNotes
			payload.customerNotes			= rootGetters.cxNotes
			payload.customAddress			= rootGetters.customAddress
			payload.promoCode				= rootGetters.promoCode
			payload.rightRX					= rootGetters.rightRXDB
			payload.leftRX					= rootGetters.leftRXDB
			payload.cxFrame					= rootGetters.listCXFrame
			payload.lineItems				= rootGetters.cartProducts
			payload.tint					= rootGetters.listTint
			payload.charges					= rootGetters.cartCharges
			payload.total					= rootGetters.cartTotalPrice
			payload.chargesTotal			= rootGetters.cartTotalCharge
			payload.discounted				= rootGetters.cartTotalDiscountedPrice
			payload.override				= rootGetters.overrideTotalPrice
			return payload
		}
	},
	strict: debug
})
